import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const handleHashchange = () => {
    if (window.location.hash.substring(1) === node.dataset.hashchangeTarget) {
      load();
    }
  };

  handleHashchange();
  window.addEventListener('hashchange', handleHashchange);

  return () => {
    window.removeEventListener('hashchange', handleHashchange);
  };
};

export default Loader;
